import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import actions from './actions'
import plugins from './plugins'
import getters from './getters'
import Cookies from 'js-cookie'
import { getUserInfo } from '@/util/auth'

Vue.use(Vuex)

// 系统默认语言
let lang = navigator.language
if (lang.indexOf('zh') !== -1) {
  lang = 'zh'
}
if (lang.indexOf('en') !== -1) {
  lang = 'en'
}

export default new Vuex.Store({
  state: {
    language: Cookies.get('language') || lang,
    loading: {
      verifyCodeLoading: false,
      userInfoLoading: false,
      eventLoading: false,
      eventListLoading: false,
      registeredEventListLoading: false,
      registerEventLoading: false,
      approvedEventLoading: false,
      lookupLoading: false,
      applyLookupLoading: false,
      anchorFormLoading: false,
      campaignIdLoading: false,
      tokenRefreshing: false,
      saveSurveyLoading: false,
      checkUserExistLoading: false,
      submitBtnLoading: false,
      saveNewSurveyAnswerLoading: false
    },
    lookups: {},
    applyLookups: {},
    userInfo: Object.assign(
      {
        countryCode: 86
      },
      getUserInfo()
    ),
    eventList: [],
    registeredEvents: [],
    approvedEvents: [],
    anchorForm: {},
    campaignId: '',
    tempFiles: {},
    tempSurvey: {},
    video: JSON.parse(localStorage.getItem('_video_') || '{}')
  },
  getters,
  actions,
  mutations,
  plugins
})
